<script lang="ts">
  import { onMount } from "svelte";
  import { headerDisplayStore, loadingStore } from "../stores/General";
  import { navigate } from "svelte-navigator";
  import Button from "../components/button/RouteButton.svelte";
  import { getList, update } from "../api";
  import { numberFormatted } from "../utils/conv";
  import ActivateModal from "../components/modal/ActivateModal.svelte";
  import Table from "../components/table/Table.svelte";
  import { Column } from "../components/table/types.svelte";
  import GenericButton from "../components/button/GenericButton.svelte";
  import { Exclamation } from 'svelte-hero-icons';

  let showModal = false;
  let modalData: any = {}; // TODO: declare type
  let demand_partner_types = [];
  let downloadLoading = false;
  const module_name = "demand";
  const tableId = "demand_partners";

  onMount(() => {
    headerDisplayStore.SetTitle("Demand Partners");
    headerDisplayStore.SetBreadCrumbs([
      {
        key: "demand",
        label: "Demand Partners",
      },
      {
        key: "list",
        label: "List",
      },
    ]);
    loadData();
  });

  function formatDemandPartnerType(demand_partner_id) {
    if (demand_partner_id === null) return " ";
    return (
      demand_partner_types.length &&
      (demand_partner_types.find((type) => type.id === demand_partner_id)
        ?.name ||
        " ")
    );
  }
  function editAction(value) {
    navigate(`/demand_partners/edit/${value.demand_partner_id}`);
  }

  function openDetail(value) {
    console.log(value);
  }

  const masking = {
    mask: "-",
    values: ["0", null, 0, undefined],
  };

  const width = "150";
  const columns: Column[] = [
    {
      label: "Demand Partner",
      dataKey: "name",
      sortBy: "name",
      renderBy: "formatter",
    },
    {
      label: "Demand Partner ID",
      dataKey: "demand_partner_id",
      sortBy: "demand_partner_id",
      renderBy: "formatter",
    },
    {
      label: "Type",
      dataKey: "demand_partner_type",
      renderBy: "formatter",
      sortBy: "demand_partner_type",
      formatter: formatDemandPartnerType,
    },
    // {
    //   label: "Blocklist Category",
    //   dataKey: "category",
    //   renderBy: "formatter",
    //
    //   masking,
    // },
    {
      label: "Max Bid Floor",
      dataKey: "max_bid_floor",
      renderBy: "formatter",

      formatter: numberFormatted,
      masking,
    },
    {
      renderBy: "actions",
      width: "55",
      actions: [
        { key: "edit", label: "Edit", icon: "edit", type: "button" },
        {
          key: "activate",
          label: "Activate",
          icon: "",
          name: "disabled",
          type: "submit",
        },
      ],
    },
  ];
  let pageSize = 10;
  let data = [];
  let selectedIds = [];
  let count = 0;
  let page = 1;
  let sortBy = "created_at";
  let sortOrder = "DESC";
  let filter: any = { disabled: false }; // TODO: declare type
  let pagination = { page, pageSize, count };

  let filters = [
    { label: "Search", key: "name", filter: "text" },
    { label: "Demand Partner ID", key: "demand_partner_id", filter: "text" },
    {
      label: "Show Deactivated",
      key: "disabled",
      filter: "boolean",
    },
  ];
  function formatData(data) {
    return data.map((dp) => {
      if (dp.block_list?.length) {
        let categories = [
          ...new Set(
            dp.block_list.map((bl) => bl.categories?.map((d) => d.label) || [])
          ),
        ];
        dp.category = categories.includes("All Categories")
          ? "All Categories"
          : categories.join(", ");
        delete dp.block_list;
      }
      return dp;
    });
  }
  function loadData() {
    let mainSettingsArray = JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

    pagination = {...pagination, ...mainSettingsArray?.pagination};

    if (pagination !== null){
      pageSize = pagination.pageSize;
      page = pagination.page;
    }

    data = [];
    loadingStore.on(module_name);

    // getList(module_name, pageSize, page, sortBy, sortOrder, filter)
    //   .then((response) => {
    //     loadingStore.off(module_name);
    //     data = response.data;
    //     count = response.count;
    //   })
    //   .catch((error) => {
    //     loadingStore.off(module_name);
    //     headerDisplayStore.ShowError({
    //       title: "Server error",
    //       subtitle: error?.message,
    //     });
    //   });

    getList(module_name, pageSize, page, sortBy, sortOrder, filter)
      .then(async (response) => {
        await getList(module_name + "/types", pageSize, page, "name", "ASC", {})
          .then((typeResponse) => {
            demand_partner_types = typeResponse.data;
          })
          .catch((error) => {
            headerDisplayStore.ShowError({
              title: "Server error",
            });
          });
        // temporary solution the mapping should be done in om-core
        data = formatData(response.data);
        pagination.count = response.count;
        loadingStore.off(module_name);
      })
      .catch((error) => {
        loadingStore.off(module_name);
        headerDisplayStore.ShowError({
          title: "Server error",
        });
      });
  }

  function onPageChange(event) {
    let mainSettingsArray= JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );
      mainSettingsArray ={...mainSettingsArray, pagination:event.detail};

      localStorage.setItem(
      `_tableMainSettings_${tableId}`,
      JSON.stringify(mainSettingsArray)
    );

    page = event.detail.page;
    pageSize = event.detail.pageSize;
    loadData();
  }

  function onSortChange(event) {
    sortBy = event.detail.sortBy;
    sortOrder = event.detail.sortOrder;
    loadData();
  }

  function onFilterChange(event) {
    filter = event.detail.filter;
    filter.disabled = !!filter.disabled;
    page = 1;
    loadData();
  }
  function onActionClick({ detail }) {
    const { action, row } = detail;

    switch (action.key) {
      case "edit":
        editAction(row);
        break;
      case "activate":
        ToggleModal(row);
        break;
    }
  }
  function handleCheckedChange(event) {
    selectedIds = event.detail.selectedIds;
  }

  //Function that takes a component to be rendered in the base modal and the action.
  function ToggleModal(partner) {
    //modalData is an object sending all necessary data to the modal
    modalData.demand_partner_id = partner.demand_partner_id;
    modalData.partner_disabled = partner.disabled;
    modalData.headerText = "Warning";
    modalData.Icon = Exclamation;
    if (partner.disabled == true) {
      modalData.body = "Are you sure you want to activate the Demand Partner?";
      modalData.rightButtonText = "Activate";
      modalData.rightButtonType = "success-solid";
    } else {
      modalData.body =
        "Are you sure you want to deactivate the Demand Partner?";
      modalData.rightButtonText = "Deactivate";
      modalData.rightButtonType = "danger-solid";
    }
    showModal = !showModal;
  }

  async function ToggleActivate() {
    let toggleData: any = {}; // TODO: declare type
    toggleData.demand_partner_id = modalData.demand_partner_id;
    toggleData.disabled = !modalData.partner_disabled;

    await update(module_name, toggleData)
      .then((response) => {
        if (response?.status === "ok") {
          headerDisplayStore.ShowNotification({
            title: "Success",
            subtitle: "Partner saved successfully",
          });
          loadData();
          onCancel();
        } else {
          headerDisplayStore.ShowError({
            title: "Error",
            subtitle: response?.error,
          });
        }
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
      });
  }

  function onCancel() {
    navigate("/demand_partners");
  }

  function download() {
    downloadLoading = true;
    getList(module_name, null, null, sortBy, sortOrder, {})
      .then(({ data }) => {
        const a = document.createElement("a");
        data = formatData(data);
        const file = new Blob([JSON.stringify(data)], {
          type: "text/plain",
        });
        a.href = URL.createObjectURL(file);
        a.download = "demand.json";
        a.click();
        downloadLoading = false;
      })
      .catch((error) => {
        headerDisplayStore.ShowError({
          title: "Server error",
          subtitle: error?.message,
        });
        downloadLoading = false;
      });
  }
</script>

<div class="flex flex-col h-full">
  <div class="w-full sm:px-6">
    <div class="py-2 md:py-2">
      <div class="sm:flex items-center justify-between">
        <div />
        <div
          class="flex justify-center z-0 shadow-sm rounded-md sm:shadow-none sm:space-x-6"
        >
          <Button name="New Demand Partner" route="/demand_partners/new" />
          <!-- <button
            type="button"
            on:click={() => {
              download();
            }}
            class="w-48 h-10 relative inline-flex items-center justify-center px-4 py-1 rounded-md border shadow-nv border-custom-orange text-sm font-medium text-custom-orange hover:bg-custom-orange hover:text-custom-white focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
          >
            <span> Export Json</span>
          </button> -->
          <GenericButton
            onClick={download}
            text=" Export Json"
            buttonTheme="outline-clear"
            disabled={downloadLoading}
            loading={downloadLoading}
            height="2.5rem"
            width="12rem"
          />
        </div>
      </div>
    </div>
    <Table
      {columns}
      {filters}
      defaultConfig={{
        tableId,
        stickyHeader: true,
        stickyFirstColumn: true,
        stickyLastColumn: true,
        multilineColumns: false,
        showCheckboxes: false,
        enableDeleteAll: false,
        enableSubTables: false,
      }}
      loader={$loadingStore.loading}
      bind:data
      dataKey="demand_partner_id"
      {pagination}
      sorting={{ sortBy, sortOrder }}
      {selectedIds}
      on:pageChange={onPageChange}
      on:sortChange={onSortChange}
      on:filterChange={onFilterChange}
      on:actionClick={onActionClick}
      on:checkedChange={handleCheckedChange}
      on:sortClick={onSortChange}
    />
  </div>
</div>
{#if showModal}
  <ActivateModal
    on:click={ToggleModal}
    {modalData}
    on:modalSubmit={ToggleActivate}
  />
{/if}
